module.exports = __webpack_public_path__ + "static/media/icons8-github.27c09cb9.svg";